import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { Slide } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'grid',
    justifyItems: 'stretch',
    alignItems: 'center',
    height: 150,
  },
});

const EmailForm = ({ classes, email, setEmail }) => {
  return (
    <div className={classes.root}>
      <TextField
        required
        type="email"
        helperText="Enter your email so we can send you a reset code."
        placeholder="person@whiteretail.com"
        value={email}
        onChange={e => setEmail(e.target.value)}
        variant="outlined"
      />
    </div>
  );
};

export default withStyles(styles)(EmailForm);
